module.exports = __webpack_public_path__ + "img/about-m-slide-27.4f133915.jpg";